import { useResizeObserver } from "@react-hookz/web";
import { useRef, useState } from "react";

export function useIsSingleLine(shouldCheck: boolean, lineHeight: number = 30) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSingleLine, setIsSingleLine] = useState(false);
  useResizeObserver(containerRef, (entry) => {
    if (!shouldCheck) return;
    const height = entry.contentRect.height;
    setIsSingleLine(height <= lineHeight);
  });
  return { isSingleLine, containerRef };
}
